import type { GridPaginationModel } from "@mui/x-data-grid-premium";

/** User-visible total pages for server-side pagination (min 1, including empty result). */
export function getServerPaginationTotalPages(
  totalCount: number,
  pageSize: number,
): number {
  if (totalCount === 0) return 1;
  return Math.max(1, Math.ceil(totalCount / pageSize));
}

/** Clamp 0-based page index to `[0, totalPages - 1]`. */
export function clampServerPaginationPage(
  page: number,
  totalCount: number,
  pageSize: number,
): number {
  const totalPages = getServerPaginationTotalPages(totalCount, pageSize);
  return Math.min(Math.max(0, page), totalPages - 1);
}

/**
 * Apply DataGrid pagination changes per Assessment Center product spec:
 * - Page size change → page 1 (index 0)
 * - Sort guard: ignore MUI auto-reset to page 0 while keeping current page
 */
export function applyAssessmentCenterPaginationChange(
  prev: GridPaginationModel,
  next: GridPaginationModel,
  sortGuardActive: boolean,
): GridPaginationModel {
  if (next.pageSize !== prev.pageSize) {
    return { page: 0, pageSize: next.pageSize };
  }
  if (sortGuardActive && next.page === 0 && prev.page !== 0) {
    return prev;
  }
  return next;
}
